<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g :fill="iconColor">
      <path
        d="M22.125 0.75C22.4375 0.75 22.75 1.0625 22.75 1.375V2.3125V16.6875V17.625C22.75 17.9766 22.4375 18.25 22.125 18.25C21.7734 18.25 21.5 17.9766 21.5 17.625V17.1953L13.8828 15.2812C13.5312 17 12.0469 18.25 10.25 18.25C8.17969 18.25 6.5 16.5703 6.5 14.5C6.5 14.1484 6.53906 13.7969 6.61719 13.4844L1.5 12.1953V12.625C1.5 12.9766 1.1875 13.25 0.875 13.25C0.523438 13.25 0.25 12.9766 0.25 12.625V11.8828V11.375V7.625V7.15625V6.375C0.25 6.0625 0.523438 5.75 0.875 5.75C1.1875 5.75 1.5 6.0625 1.5 6.375V6.84375L21.5 1.84375V1.375C21.5 1.0625 21.7734 0.75 22.125 0.75ZM21.5 15.9062V3.13281L1.5 8.13281V10.9062L21.5 15.9062ZM7.75 14.5C7.75 15.9062 8.84375 17 10.25 17C11.4609 17 12.4766 16.1406 12.6719 15.0078L7.82812 13.7969C7.78906 14.0312 7.75 14.2656 7.75 14.5Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
